import { SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPSELL_NIBBLES_METHOD = "PATCH";
export const SUBSCRIPTIONS_CUSTOMER_UPSELL_NIBBLES_PATH_SUFFIX = "/extras/upsell/nibbles";
/** /customer/subscription/fresh/extras/upsell/nibbles */
export const SUBSCRIPTIONS_CUSTOMER_UPSELL_NIBBLES_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_UPSELL_NIBBLES_PATH_SUFFIX
}`;
